import { memo } from 'react';

import { SquareImage } from '@components/square-image';

import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.integration;

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  const integration = node.data.integration;
  const icon = integration?.thumbnail ? <SquareImage src={integration.thumbnail} /> : undefined;
  const endpointName = integration?.name ?? getActionLabel(ACTION_TYPE);
  const integrationName = integration?.integrationName;

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        label={endpointName}
        subLabel={integrationName}
        descriptionText={node.data?.description}
        isConfigured={node.data.isConfigured}
        icon={icon}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});
